(function(){
    angular.module('update-field-action.dir', [])
        .directive('updateFieldAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService','CANVAS_OPTS', '$timeout', updateFieldAction]);

    function updateFieldAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function($scope){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function(dummy){
                    const check = $scope.dataFilledCorrectly();
                    $rootScope.$emit('displayActionUpdateFieldModalError', check.errors);

                    //If form data is missing
                    if(check.result === false) {
                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else{
                        if(!dummy && $scope.connections.isDummy) {
                            delete $scope.connections.isDummy;
                        }

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if(parentData){
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        if(!$scope.connections.isDummy) {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }
                        }

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionUpdateFieldModal');
                        //Displays action menu
                        $scope.displaySubMenu = false;
                        //Hides Error
                        $scope.displayError = false;
                        $scope.errorDelay = false;
                        $scope.errorUnits = false;
                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                        if ($scope.isElegibleForUpdate && !dummy) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 1500);
                        }

                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                // validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    let res = true,
                        errorList = [];

                    $scope.connections.data.fields.map((f, index) => {
                        errorList.push({});

                        if (!f.pickedField) {
                            errorList[index].pickedField = true;
                            res = false;
                        } else {
                            errorList[index].pickedField = false;
                        }

                        if (!f.pickedList) {
                            errorList[index].pickedList = true;
                            res = false;
                        } else {
                            errorList[index].pickedList = false;
                        }
                    });

                    return {
                        result: res,
                        errors: errorList
                    };
                };

                $scope.toggleConnectionMenu = function (event) {
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none'){
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideActionUpdateFieldModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1 || $scope.connections.isDummy) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                            } else if (!$scope.dataFilledCorrectly().result) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideActionUpdateFieldModal');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideActionUpdateFieldModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function(){
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if(conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function(evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        $rootScope.$emit('hideActionUpdateFieldModal');
                        return false;
                    }
                    //Show form menu
                    if($scope.displayList === false){
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                    }else{
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionUpdateFieldModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function () {
                    if(!$scope.connections) return;

                    let description = '';
                    const fieldCount = $scope.connections && $scope.connections.data && $scope.connections.data.fields.length;
                    if(fieldCount) {
                        if(fieldCount > 1) {
                            description = `${fieldCount} Fields`;
                        } else {
                            description = $scope.connections.data.fields[0].pickedFieldName
                        }
                    }

                    let fieldsDesc = '';
                    $scope.connections.data.fields.map((i) => {
                        fieldsDesc += `<tr><td>${i.pickedFieldName}</td><td>${i.updateTo}</tr>`;
                    });

                    $scope.descriptionTooltip = `<table class=contactUsageBreakdown-table><tbody>${fieldsDesc}</tbody></table>`;

                    return description;
                };

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $rootScope.$on('generateWaitTime', (evt, id) => {
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    if(!$rootScope.delayConns.includes(id) && !$scope.hasChildren(id)) {
                        $rootScope.currentDelayConn = id;
                        $rootScope.delayConns.push(id);
                        plumbService.setLastElemClicked(id);
                        $timeout(() => {$(`#${id} li[add-wait-time-action]`).click()}, 0);
                    }
                });

                $scope.hasChildren = function(id) {
                    let el = helpers.getConnectionById(id);

                    return (el.children && el.children.length > 0);
                };

                $scope.saveEvents = function() {
                    $rootScope.$on('saveActionUpdateFieldData' + $scope.connections.id, function(evt, conn) {
                        $scope.tempConn = angular.copy($scope.connections);
                        $scope.connections = angular.copy(conn);
                        $scope.save();
                    });
                };

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    var template = $templateCache.get('actions/update-field');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.saveEvents();
                    scope.save(true);
                }

                // when a directive is clicked
                $(elem).click(function (evt) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    $rootScope.activePlus = false;

                    if($rootScope.currentDelayConn) {
                        scope.currentDelayConn = $rootScope.currentDelayConn;
                        delete $rootScope.currentDelayConn;
                    }

                    //Load Template
                    var template = $templateCache.get('actions/update-field'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);


                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: {fields: []},
                        elemClass: attr.$attr,
                        elemName: 'UpdateFields',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if(scope.displayError) {
                            $timeout(function() {
                                scope.displayList = true;
                                $rootScope.$emit('displayActionUpdateFieldModal', scope.connections);
                            }, 250)
                        }
                    });

                    scope.saveEvents();

                    // Listener when user cancel the add the node of delay
                    $rootScope.$on('deleteUpdateFieldNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    if(!scope.currentDelayConn) {
                        $rootScope.$emit('displayActionUpdateFieldModal', scope.connections);
                    } else {
                        // setting default data
                        scope.connections.data = {delay: 24, units: 'hours'};
                        scope.save();
                    }

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function() {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    scope.connections = null;
                    scope.currentDelayConn = null;
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    $rootScope.delayConns.splice(scope.currentDelayConn, 1);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/update-field-action.js